// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"34a038e0","161":"8743e1b7"}[chunkId] + ".chunk.css";
};